import { createSlice } from '@reduxjs/toolkit';

export interface conciergeSliceState {
    visible: boolean;
    closeChat: boolean;
    onlySearch: boolean;
    width: number;
    newChat: string | null;
}

export const conciergeSlice = createSlice({
    name: 'concierge',
    initialState: {
        visible: false,
        width: 420,
        newChat: null,
        onlySearch: false,
    } as conciergeSliceState,
    reducers: {
        show: (state) => {
            state.visible = true;
        },
        hide: (state) => {
            state.visible = false;
        },
        toggleVisibility: (state) => {
            state.visible = !state.visible;
        },
        setConciergeWidgetWidth: (state, action) => {
            state.width = action.payload;
        },
        startNewChat: (state, action) => {
            state.newChat = action.payload;
        },
        clearNewChat: (state) => {
            state.newChat = null;
        },
        closeChat: (state, action) => {
            state.closeChat = action.payload;
        },
        setOnlySearch: (state, action) => {
            state.onlySearch = action.payload;
        },
    },
});

export const {
    show,
    hide,
    toggleVisibility,
    setConciergeWidgetWidth,
    startNewChat,
    clearNewChat,
    closeChat,
    setOnlySearch,
} = conciergeSlice.actions;

export default conciergeSlice.reducer;
